import React from 'react'
import { Updater, fromJSX, Widget } from 'widgets-for-react'
import { BmiBlockState, bmiBlockStateUpdaters } from './bmiBlockState'
import { BmiBlockLayout } from './bmiBlockLayout'
import { BmiBlock } from '../../blocksState'

//Function to calculate the BMI.
export const calculateBMI: (w: number | undefined, l: number | undefined) => number | undefined = (
  weight: number | undefined,
  length: number | undefined
) => {
  if (weight && length) {
    const l: number = length > 100 ? length / 100 : length
    return weight / (l * l)
  } else {
    return undefined
  }
}

//Function to calculate overweight.
export const calculateOverweight: (w: number | undefined, l: number | undefined) => number | undefined = (
  weight: number | undefined,
  length: number | undefined
) => {
  if (weight && length) {
    const l: number = length > 100 ? length / 100 : length
    return weight - 25 * l * l
  } else {
    return undefined
  }
}

// This widget loads in the layout along with the functions required to change the state.
export const bmiBlockWidget = (block: BmiBlock): Widget<Updater<BmiBlockState>> =>
  fromJSX((setState) => (
    <BmiBlockLayout
      index={block.index}
      age={block.bmiBlockState.age}
      length={block.bmiBlockState.length}
      weight={block.bmiBlockState.weight}
      gastricBand={block.bmiBlockState.gastricBand}
      setAge={(num) => setState(bmiBlockStateUpdaters.updateAge(num))}
      setLength={(num) => setState(bmiBlockStateUpdaters.updateLength(num))}
      setWeight={(num) => setState(bmiBlockStateUpdaters.updateWeight(num))}
      setBool={(bool, prop, depth) => setState(bmiBlockStateUpdaters.updateBool(bool, prop, depth))}
      bmi={calculateBMI(block.bmiBlockState.weight, block.bmiBlockState.length)}
      overweight={calculateOverweight(block.bmiBlockState.weight, block.bmiBlockState.length)}
      bmiBlockState={block.bmiBlockState}
    />
  ))
